<template>
  <div v-if="showInstallPrompt" class="install-banner">
    <div class="install-content">
      <div class="install-icon">
        <i class="bi bi-download"></i>
      </div>
      <div class="install-text">
        <h5>¡Instala AMI DRIVER!</h5>
        <p>Acceso más rápido y funcionalidad sin conexión</p>
      </div>
      <div class="install-actions">
        <button @click="installApp" class="btn-install">
          Instalar
        </button>
        <button @click="dismissPrompt" class="btn-dismiss">
          <i class="bi bi-x"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InstallBanner',
  data() {
    return {
      deferredPrompt: null,
      showInstallPrompt: false,
      dismissed: false,
      isAppInstallable: false,
      isStandalone: false
    }
  },
  mounted() {
    // Verificar si el usuario ya ha descartado el prompt
    const dismissed = localStorage.getItem('pwaPromptDismissed')
    if (dismissed && (new Date().getTime() - parseInt(dismissed)) < 604800000) { // 7 días
      this.dismissed = true
    }

    // Verificar si la app ya está instalada
    this.checkIfAppIsInstalled()

    // Escuchar el evento beforeinstallprompt
    window.addEventListener('beforeinstallprompt', (e) => {
      console.log('🔥 Evento beforeinstallprompt capturado')
      // Prevenir que Chrome muestre el prompt automático
      e.preventDefault()
      // Guardar el evento para usarlo más tarde
      this.deferredPrompt = e
      this.isAppInstallable = true
      
      // Mostrar nuestro banner personalizado si no ha sido descartado
      if (!this.dismissed && !this.isStandalone) {
        // Esperar un momento antes de mostrar el banner
        setTimeout(() => {
          this.showInstallPrompt = true
        }, 3000) // Mostrar después de 3 segundos
      }
    })

    // Detectar si la app ya está instalada
    window.addEventListener('appinstalled', () => {
      this.showInstallPrompt = false
      this.deferredPrompt = null
      this.isStandalone = true
      // Registrar que la app fue instalada
      console.log('¡AMI DRIVER fue instalada correctamente!')
      localStorage.setItem('appInstalled', 'true')
    })

    // Verificar periódicamente si la app es instalable
    // Esto es un fallback por si el evento beforeinstallprompt no se dispara
    this.checkInstallability()
    
    // Crear un evento personalizado para escuchar cambios en el estado de instalación
    window.addEventListener('app-install-status-changed', (event) => {
      if (event && event.detail) {
        this.isStandalone = event.detail.isInstalled;
        if (this.isStandalone) {
          this.showInstallPrompt = false;
        }
      }
    });
  },
  methods: {
    checkIfAppIsInstalled() {
      // Detectar si la app está en modo standalone (instalada)
      try {
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches
        const isIOSStandalone = window.navigator && window.navigator.standalone === true
        this.isStandalone = isStandalone || isIOSStandalone || localStorage.getItem('appInstalled') === 'true'
        
        console.log('InstallBanner - Estado de instalación:', this.isStandalone)
        
        if (this.isStandalone) {
          this.showInstallPrompt = false
        }
      } catch (error) {
        console.error('Error al verificar instalación:', error)
      }
    },
    checkInstallability() {
      // Verificar si la app cumple con los requisitos para ser instalable
      const isHttps = window.location.protocol === 'https:' || window.location.hostname === 'localhost'
      const hasManifest = !!document.querySelector('link[rel="manifest"]')
      
      // Si estamos en desarrollo, forzar la visualización del banner después de 5 segundos
      // si no se ha disparado el evento beforeinstallprompt
      if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        setTimeout(() => {
          if (!this.deferredPrompt && !this.dismissed && !this.isStandalone && !this.showInstallPrompt) {
            console.log('Forzando visualización del banner en entorno de desarrollo')
            this.showInstallPrompt = true
            this.isAppInstallable = true
          }
        }, 5000)
      }
      
      console.log('Verificación de instalabilidad:', { 
        isHttps, 
        hasManifest,
        hostname: window.location.hostname
      })
    },
    async installApp() {
      if (this.deferredPrompt) {
        // Si tenemos el evento beforeinstallprompt, usarlo
        try {
          // Mostrar el prompt de instalación
          this.deferredPrompt.prompt()
          
          // Esperar a que el usuario responda
          const { outcome } = await this.deferredPrompt.userChoice
          
          // Registrar el resultado
          console.log(`Usuario respondió: ${outcome}`)
          
          // Limpiar el prompt guardado
          this.deferredPrompt = null
          this.showInstallPrompt = false
          
          if (outcome === 'accepted') {
            localStorage.setItem('appInstalled', 'true')
          }
        } catch (error) {
          console.error('Error al mostrar prompt de instalación:', error)
        }
      } else {
        // Si no tenemos el evento, mostrar instrucciones manuales
        this.showManualInstructions()
      }
    },
    dismissPrompt() {
      this.showInstallPrompt = false
      // Guardar timestamp para no mostrar por 7 días
      localStorage.setItem('pwaPromptDismissed', new Date().getTime().toString())
      this.dismissed = true
    },
    showManualInstructions() {
      // Detectar navegador
      const ua = navigator.userAgent
      let instructions = ''
      
      if (/chrome/i.test(ua) && /android/i.test(ua)) {
        instructions = 'Para instalar AMI DRIVER: Toca los tres puntos en la esquina superior derecha y selecciona "Añadir a pantalla de inicio"'
      } else if (/chrome/i.test(ua)) {
        instructions = 'Para instalar AMI DRIVER: Haz clic en el icono de instalación en la barra de direcciones (extremo derecho)'
      } else if (/firefox/i.test(ua)) {
        instructions = 'Para instalar AMI DRIVER: Toca los tres puntos en la barra de direcciones y selecciona "Instalar"'
      } else if (/safari/i.test(ua) && !/chrome/i.test(ua)) {
        instructions = 'Para instalar AMI DRIVER: Toca el icono de compartir y luego "Añadir a pantalla de inicio"'
      } else {
        instructions = 'Para instalar AMI DRIVER: Busca la opción "Instalar" o "Añadir a pantalla de inicio" en el menú de tu navegador'
      }
      
      // Mostrar instrucciones (puedes usar un modal o alert)
      alert(instructions)
    }
  }
}
</script>

<style scoped>
.install-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: white;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding: 12px 16px;
  border-top: 3px solid #5d4fad;
  animation: slideUp 0.3s ease-out;
}

.install-content {
  display: flex;
  align-items: center;
  max-width: 100%;
}

.install-icon {
  font-size: 24px;
  color: #5d4fad;
  margin-right: 16px;
}

.install-text {
  flex: 1;
}

.install-text h5 {
  margin: 0;
  font-weight: bold;
  color: #333;
}

.install-text p {
  margin: 4px 0 0;
  font-size: 14px;
  color: #666;
}

.install-actions {
  display: flex;
  align-items: center;
}

.btn-install {
  background-color: #c8ff00;
  color: #333;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
  margin-right: 8px;
}

.btn-dismiss {
  background: none;
  border: none;
  color: #999;
  font-size: 20px;
  cursor: pointer;
  padding: 4px;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}
</style>
